import { TreeNode } from "./tree-node.js";
export class TreeNodeChildren {
    constructor(items) {
        this._value = [];
        if (items === null || items === void 0 ? void 0 : items.length)
            this._value = items;
    }
    add(node, parentId) {
        const n = new TreeNode(node, parentId);
        this._value.push(n);
    }
    remove(id) {
        const idx = this._value.findIndex((i) => i.id() === id);
        if (idx)
            this._value.splice(idx, 1);
    }
    getNodes() {
        return this._value;
    }
    values() {
        var _a;
        return (_a = this._value) === null || _a === void 0 ? void 0 : _a.map((n) => n.value());
    }
}
//# sourceMappingURL=tree-node-children.js.map